<template>
    <v-container fluid class="mt-0 pt-0">
        <v-row>
            <v-col class="mt-0 pt-0">
                <v-card>
                    <v-card-title>
                        <div>
                            <p class="subtitle-2 mb-0">
                                {{ this.$store.state.monthlyDetail.detailYear }}.
                                {{ this.$store.state.monthlyDetail.detailMonth }}.
                                havi
                            </p>
                            <p class="display-1 font-weight-thin text--primary mt-0">Statisztika</p>
                        </div>
                    </v-card-title>
                    <v-container fluid class="mt-0 pt-0">
                        <v-row>
                            <v-col cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="this.$store.state.monthlyDetail.monthlyDetail.all.worktime" datatext="Munkaidő"/>
                            </v-col>
                            <v-col  cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="this.$store.state.monthlyDetail.monthlyDetail.all.breaktime" datatext="Szünet"/>
                            </v-col>
                            <v-col  cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="this.$store.state.monthlyDetail.monthlyDetail.all.correction" datatext="Korrekció"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col  cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="`${this.$store.state.monthlyDetail.monthlyDetail.all.days}`" datatext="Összes nap"/>
                            </v-col>
                            <v-col  cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="`${this.$store.state.monthlyDetail.monthlyDetail.all.realworkday}`" datatext="Munkanapok"/>
                            </v-col>
                            <v-col  cols="12" sm="12" lg="4">
                                <UserDetailStaticsCard :data="`${this.$store.state.monthlyDetail.monthlyDetail.all.workdays}`" datatext="Ledolgozott napok"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import UserDetailStaticsCard from "./UserDetailStaticsCard";
    export default {
        name: "UserDetailStatics",

        components: {
            UserDetailStaticsCard
        }
    }
</script>

<style scoped>

</style>
